export default __webpack_public_path__ + "3acc0e04861af0a840a524e022ca1d5d.jpg";